import React from 'react'

export const UserProfile = () => {

    return (
        <>
            Hello, user name
        </>
    )
}